/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const ActorType = zod.enum(['system', 'user']);

export type ActorType = zod.input<typeof ActorType>;
export type ActorTypeOutput = zod.output<typeof ActorType>;
